<!-- Component Header with Loading State and Refresh Button -->
<div class="sentiment-header">
  <div class="header-content">
    <h2 class="component-title">
      <mat-icon>sentiment_very_satisfied</mat-icon>
      {{ title }}
    </h2>
    <div class="header-actions">
      @if (isLoading) {
        <mat-spinner diameter="24"></mat-spinner>
        <span class="loading-text">Loading...</span>
      } @else {
        <button mat-icon-button (click)="refreshData()" matTooltip="Refresh Data">
          <mat-icon>refresh</mat-icon>
        </button>
      }
    </div>
  </div>
  @if (error) {
    <div class="error-message">
      <mat-icon>error</mat-icon>
      <div class="error-content">
        <span class="error-text">{{ error }}</span>
        <button mat-button color="primary" (click)="refreshData()" [disabled]="isLoading">
          <mat-icon>refresh</mat-icon>
          Retry
        </button>
      </div>
    </div>
  }
</div>

<!-- <pre>{{(data | json)}}</pre> -->
<!-- New Overview-like Layout -->
@if (data && data.universities && data.universities.length > 0) {
<div class="education-overview-container">

  <!-- Top Row: Score Widget and Chart -->
  <div class="top-row">
    <!-- Composite Score Widget -->
    <app-composite-score-widget
      [compositeScore]="data.composite_score || sentimentBreakdown || 0"
      [title]="'Overall Sentiment'"
      [size]="'medium'">
    </app-composite-score-widget>

    <!-- Sentiment Analysis Chart -->
    <div class="chart-section">
      <div class="chart-header">
        <div class="chart-title-section">
          <h4 class="chart-title">Sentiment Analysis Index</h4>
          <p class="chart-subtitle">{{ getChartSubtitle() }}</p>
        </div>
      </div>

      <!-- Sentiment Analysis Chart -->
      <div class="chart-mobile-wrapper">
        <div *ngIf="shouldShowComboChart()" class="combo-chart-wrapper">
          <app-bar-line-combo-chart
            [view]="view"
            [scheme]="comboBarScheme"
            [colorSchemeLine]="lineChartScheme"
            [results]="results"
            [lineChart]="lineChart"
            [barBrandName]="'Bar Chart'"
            [animations]="true"
            [tooltipDisabled]="false"
            [yAxisTickFormatting]="yLeftTickFormat"
            [yLeftAxisScaleFactor]="yLeftAxisScale"
            [yRightAxisScaleFactor]="yRightAxisScale"
            [yRightAxisTickFormatting]="yRightTickFormat"
            [gradient]="false"
            [xAxis]="true"
            [yAxis]="true"
            [legend]="true"
            [legendTitle]="'Universities'"
            [legendPosition]="'right'"
            [showGridLines]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [showRightYAxisLabel]="true"
            [xAxisLabel]="'Sentiment Metrics'"
            [yAxisLabel]="'Score'"
            [yAxisLabelRight]="'Score'"
            [noBarWhenZero]="true"
            [wrapTicks]="false"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)">
          </app-bar-line-combo-chart>
        </div>
      </div>
    </div>
  </div>

  <!-- Sentiment Radar Chart -->
  @if (sentimentRadarData && sentimentRadarData.length > 0) {
  <div class="radar-chart-section">
    <h3>Sentiment Analysis Radar</h3>
    <app-polar-chart [polarChartData]="sentimentRadarData">
    </app-polar-chart>
  </div>
  }

  <!-- Performance Table -->
  <app-common-performance-table
    [rows]="tableRows"
    [columns]="tableColumns"
    [title]="'Overall Sentiment Performance'">
  </app-common-performance-table>

  <!-- Sentiment Tracking Table -->
  @if (sentimentTrackingTableRows && sentimentTrackingTableRows.length > 0) {
  <app-common-performance-table
    [rows]="sentimentTrackingTableRows"
    [columns]="sentimentTrackingTableColumns"
    [title]="'Sentiment Tracking Metrics'">
  </app-common-performance-table>
  }

  <!-- Sentiment Trends Section -->
  <app-sentiment-trends
    [sentimentTrends]="data.sentiment_trends"
    [title]="'Sentiment Trends Analysis'">
  </app-sentiment-trends>

  <!-- Sources Section -->
  <app-common-sources
    [evidenceSources]="data.evidence_sources"
    [title]="'Sentiment Analysis Sources'"
    [showTitle]="true">
  </app-common-sources>

  <!-- Recommendations (Hidden for now) -->
  <!-- <app-evidence-and-recommendations
    [evidenceSources]="evidenceSources"
    [recommendations]="recommendations"
    [evidenceTitle]="'Sentiment Analysis Sources'"
    [recommendationsTitle]="'Sentiment Improvement Recommendations'">
  </app-evidence-and-recommendations> -->

</div>
}

